import gar1 from "../assets/img/garllery/gar-1.jpg";
import gar2 from "../assets/img/garllery/gar-2.jpg";
import gar3 from "../assets/img/garllery/gar-3.jpg";
import gar4 from "../assets/img/garllery/gar-4.jpg";
import gar5 from "../assets/img/garllery/gar-5.jpg";
import gar6 from "../assets/img/garllery/gar-6.jpg";
import gar7 from "../assets/img/garllery/gar-7.jpg";
import gar8 from "../assets/img/garllery/gar-8.jpg";
import gar9 from "../assets/img/garllery/gar-9.jpg";
import gar10 from "../assets/img/garllery/gar-10.jpg";
import gar11 from "../assets/img/garllery/gar-11.jpg";
import gar12 from "../assets/img/garllery/gar-12.jpg";
import gar13 from "../assets/img/garllery/gar-13.jpg";
import gar14 from "../assets/img/garllery/gar-14.jpg";
import gar15 from "../assets/img/garllery/gar-15.jpg";
import gar16 from "../assets/img/garllery/gar-16.jpg";
import gar17 from "../assets/img/garllery/gar-17.jpg";
import gar18 from "../assets/img/garllery/gar-18.jpg";
import gar19 from "../assets/img/garllery/gar-19.jpg";
import gar20 from "../assets/img/garllery/gar-20.jpg";

const garllery = [
  {
    image: gar1,
  },
  {
    image: gar2,
  },
  {
    image: gar3,
  },
  {
    image: gar4,
  },
  {
    image: gar5,
  },
  {
    image: gar6,
  },
  {
    image: gar7,
  },
  {
    image: gar8,
  },
  {
    image: gar9,
  },
  {
    image: gar10,
  },
  {
    image: gar11,
  },
  {
    image: gar12,
  },
  {
    image: gar13,
  },
  {
    image: gar14,
  },
  {
    image: gar15,
  },
  {
    image: gar16,
  },
  {
    image: gar17,
  },
  {
    image: gar18,
  },
  {
    image: gar19,
  },
  {
    image: gar20,
  },
];

export { garllery };
